import { YearmonthState } from "./types";
import { Module } from "vuex";
import { RootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getDefaultMonth } from "@/types";

export const state: YearmonthState = {
  yearmonth: getDefaultMonth().substr(0, 7),
  error: false
};

const namespaced = true;

export const yearmonth: Module<YearmonthState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};
